import React from 'react';

const TintingGallery = () => {
  const automotiveWorks = [
    { image: '../gallery/Car1.jpg' },
    { image: '../gallery/Car2.jpg' },
    { image: '../gallery/Car3.jpg' },
    { image: '../gallery/Car4.jpg' },
    { image: '../gallery/Car5.webp' },
    { image: '../gallery/Car7.jpg' },
    { image: '../gallery/Car8.jpg' },
    { image: '../gallery/home3.jpg' },
    { image: '../gallery/home4.jpg' }
  ];

  return (
    <div className="container mx-auto px-8 py-12">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold mb-2">Our Work</h1>
        <p className="text-gray-600">Browse our portfolio of professional window tinting work</p>
      </div>

      <div className="bg-gray-100 py-10 rounded-lg shadow-inner">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {automotiveWorks.map((item, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-video">
                  <img
                    src={item.image}
                    alt={`Tinted work ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TintingGallery;
